export const FETCH_PARTNER_USERS_REQUEST = 'FETCH_PARTNER_USERS_REQUEST';
export const FETCH_PARTNER_USERS_SUCCESS = 'FETCH_PARTNER_USERS_SUCCESS';
export const FETCH_PARTNER_USERS_FAILURE = 'FETCH_PARTNER_USERS_FAILURE';

export const CREATE_PARTNER_USER_REQUEST = 'CREATE_PARTNER_USER_REQUEST';
export const CREATE_PARTNER_USER_SUCCESS = 'CREATE_PARTNER_USER_SUCCESS';
export const CREATE_PARTNER_USER_FAILURE = 'CREATE_PARTNER_USER_FAILURE';

export const UPDATE_PARTNER_USER_REQUEST = 'UPDATE_PARTNER_USER_REQUEST';
export const UPDATE_PARTNER_USER_SUCCESS = 'UPDATE_PARTNER_USER_SUCCESS';
export const UPDATE_PARTNER_USER_FAILURE = 'UPDATE_PARTNER_USER_FAILURE';

// Deactivate (kept as DELETE_* for backward compatibility)
export const DELETE_PARTNER_USER_REQUEST = 'DELETE_PARTNER_USER_REQUEST';
export const DELETE_PARTNER_USER_SUCCESS = 'DELETE_PARTNER_USER_SUCCESS';
export const DELETE_PARTNER_USER_FAILURE = 'DELETE_PARTNER_USER_FAILURE';

// Activate (re-enable an INACTIVE partner user)
export const ACTIVATE_PARTNER_USER_REQUEST = 'ACTIVATE_PARTNER_USER_REQUEST';
export const ACTIVATE_PARTNER_USER_SUCCESS = 'ACTIVATE_PARTNER_USER_SUCCESS';
export const ACTIVATE_PARTNER_USER_FAILURE = 'ACTIVATE_PARTNER_USER_FAILURE';

export const SET_PARTNER_USER_FILTERS = 'SET_PARTNER_USER_FILTERS';
export const RESET_PARTNER_USER_FILTERS = 'RESET_PARTNER_USER_FILTERS';